import type { ItinerarySegments, ItinerarySegmentsPageName, TrackBasePayload } from './type';
import { page } from '$app/stores';
import { deviceType } from '$lib/services/mediaQuery/screenSize';
import { getUserId } from '$lib/services/tracking/googleAnalytics/userId';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { removeAllVMSearchParamsFromUrl } from '$lib/services/urls/searchParams';
import { get } from 'svelte/store';

const itinerarySegmentMapping: Record<ItinerarySegments, ItinerarySegmentsPageName> = {
	'recommendations': routesPagename.ROUTE_EXPLORATION as ItinerarySegmentsPageName,
	'instructions': routesPagename.ROUTE_ROADSHEET as ItinerarySegmentsPageName,
	'costs': routesPagename.ROUTE_COST as ItinerarySegmentsPageName,
	'expense-note': routesPagename.ROUTE_COST as ItinerarySegmentsPageName,
	'on-the-way': routesPagename.ROUTE_ON_THE_WAY as ItinerarySegmentsPageName,
};

export function getBasePayload(): TrackBasePayload {
	const userId = getUserId();
	const pageData = get(page);
	const activeSegment: ItinerarySegments = pageData.data.activeSegment;

	return {
		// TODO: check with thierry the string value
		site: `viamichelin-${pageData.data.locale.split('-')[1]}`,
		page_name: pageData.data.activeSegment
			? itinerarySegmentMapping[activeSegment]
			: pageData.data.pagename,
		page_location: removeAllVMSearchParamsFromUrl(window.location.href),
		device_type: get(deviceType),
		uid_status: userId ? 'connected' : 'anonymous',
		uid: userId,
		custom_event_timestamp: Date.now(),
		// TODO: Add abtest_id and abtest_variant
	};
}
